export var FieldOperatorEnum;
(function (FieldOperatorEnum) {
    FieldOperatorEnum["ALL_IN"] = "ALL_IN";
    FieldOperatorEnum["ANY_IN"] = "ANY_IN";
    FieldOperatorEnum["BETWEEN"] = "BETWEEN";
    FieldOperatorEnum["EQUAL"] = "EQUAL";
    FieldOperatorEnum["IN"] = "IN";
    FieldOperatorEnum["IS_DEFINED"] = "IS_DEFINED";
    FieldOperatorEnum["LARGER"] = "LARGER";
    FieldOperatorEnum["LARGER_EQUAL"] = "LARGER_EQUAL";
    FieldOperatorEnum["LIKE"] = "LIKE";
    FieldOperatorEnum["NOT_BETWEEN"] = "NOT_BETWEEN";
    FieldOperatorEnum["NOT_EQUAL"] = "NOT_EQUAL";
    FieldOperatorEnum["NOT_IN"] = "NOT_IN";
    FieldOperatorEnum["NOT_LIKE"] = "NOT_LIKE";
    FieldOperatorEnum["SMALLER"] = "SMALLER";
    FieldOperatorEnum["SMALLER_EQUAL"] = "SMALLER_EQUAL";
})(FieldOperatorEnum || (FieldOperatorEnum = {}));
export var FieldLogicalOperatorEnum;
(function (FieldLogicalOperatorEnum) {
    FieldLogicalOperatorEnum["AND"] = "AND";
    FieldLogicalOperatorEnum["OR"] = "OR";
})(FieldLogicalOperatorEnum || (FieldLogicalOperatorEnum = {}));
export var BuilderFieldTypeEnum;
(function (BuilderFieldTypeEnum) {
    BuilderFieldTypeEnum["BOOLEAN"] = "BOOLEAN";
    BuilderFieldTypeEnum["TEXT"] = "TEXT";
    BuilderFieldTypeEnum["DATE"] = "DATE";
    BuilderFieldTypeEnum["NUMBER"] = "NUMBER";
    BuilderFieldTypeEnum["STATEMENT"] = "STATEMENT";
    BuilderFieldTypeEnum["LIST"] = "LIST";
    BuilderFieldTypeEnum["MULTI_LIST"] = "MULTI_LIST";
    BuilderFieldTypeEnum["GROUP"] = "GROUP";
})(BuilderFieldTypeEnum || (BuilderFieldTypeEnum = {}));
export var TimeOperatorEnum;
(function (TimeOperatorEnum) {
    TimeOperatorEnum["DAYS"] = "days";
    TimeOperatorEnum["HOURS"] = "hours";
    TimeOperatorEnum["MINUTES"] = "minutes";
})(TimeOperatorEnum || (TimeOperatorEnum = {}));
export var FilterPartTypeEnum;
(function (FilterPartTypeEnum) {
    FilterPartTypeEnum["PAYLOAD"] = "payload";
    FilterPartTypeEnum["SUBSCRIBER"] = "subscriber";
    FilterPartTypeEnum["WEBHOOK"] = "webhook";
    FilterPartTypeEnum["IS_ONLINE"] = "isOnline";
    FilterPartTypeEnum["IS_ONLINE_IN_LAST"] = "isOnlineInLast";
    FilterPartTypeEnum["PREVIOUS_STEP"] = "previousStep";
    FilterPartTypeEnum["TENANT"] = "tenant";
})(FilterPartTypeEnum || (FilterPartTypeEnum = {}));
export var PreviousStepTypeEnum;
(function (PreviousStepTypeEnum) {
    PreviousStepTypeEnum["READ"] = "read";
    PreviousStepTypeEnum["UNREAD"] = "unread";
    PreviousStepTypeEnum["SEEN"] = "seen";
    PreviousStepTypeEnum["UNSEEN"] = "unseen";
})(PreviousStepTypeEnum || (PreviousStepTypeEnum = {}));
//# sourceMappingURL=builder.js.map